export default "__VITE_ASSET__bO6yRr3R__"